import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../theme/colors';

export const usePercentageBarRowStyles = makeStyles<Theme, { color?: string }>(() => ({
  root: {
    minHeight: '60px'
  },
  image: {
    width: '32px',
    color({ color = Colors.collectedGreen }) {
      return color;
    }
  },
  tooltip: {
    fontSize: '12px',
    textTransform: 'capitalize'
  },
  barWrapper: {
    marginBottom: '4px'
  },
  percentageText: {
    fontSize: '15px',
    margin: 0
  },
  countText: {
    fontSize: '11px',
    color: '#A8A8A8',
    margin: 0
  }
}));
